module.exports = __webpack_public_path__ + "static/img/4380_phase_function_Paper_PointsHejduk_Prediction.6f2a12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4380_phase_function_Paper_PointsHejduk_Prediction.png
// module id = rh38
// module chunks = 0